
import React, { createContext, useContext, useEffect, useState } from "react";
import type { Socket } from "socket.io-client";
import { getSocket } from "./socket";
import { STORAGE_KEYS } from "../constants/storageKeys";
import { getFromStorage } from "../storage";

interface SocketContextType {
  socket: Socket;
  isConnected: boolean;
}
const SocketContext = createContext<SocketContextType | null>(null);

export const SocketProvider = ({ children }: { children: React.ReactNode }) => {
  const token = getFromStorage(STORAGE_KEYS.token);
  const socket = getSocket(token);
  const [isConnected, setIsConnected] = useState(socket.connected);

  useEffect(() => {
    if (!token) return;
    socket.connect();
    socket.on("connect", () => {
      setIsConnected(true);
      console.log("Connected to socket server");
    });

    socket.on("connect_error", (err) => {
      console.error("Socket Connect Error:", err.message);
      setIsConnected(false);
    });

    socket.on("error", (err) => {
      console.error("Socket Error:", err);
    });

    socket.on("disconnect", (reason) => {
      setIsConnected(false);
      console.log("Disconnected from socket server:", reason);
    });

    return () => {
      socket.off("connect");
      socket.off("disconnect");
    };
  }, [token, socket]);

  return (
    <SocketContext.Provider value={{ socket, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocketContext = () => {
  const ctx = useContext(SocketContext);
  if (!ctx) {
    throw new Error("useSocketContext must be used inside <SocketProvider>");
  }
  return ctx;
};
